module.exports = require("@mui/icons-material/RadioButtonChecked");